import { ApplicantIndividualMessage } from '@app/models/recruiting/applicant-individual-message.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class StatusColumn extends BadgeColumn<ApplicantIndividualMessage> {
    title = 'applicant-tracker.status';
    property = 'status';
    type: CellDisplay = CellDisplay.badge;
    statusBadges: { [key: string]: BadgeDisplay } = {
        opened: { type: 'success', label: 'applicant-tracker.emailStatus.opened' },
        delivered: { type: 'default', label: 'applicant-tracker.emailStatus.delivered' },
        sent: { type: 'default', label: 'applicant-tracker.emailStatus.sent' },
        permanent_fail: { type: 'danger', label: 'applicant-tracker.emailStatus.failedToSend' },
        temporary_fail: { type: 'danger', label: 'applicant-tracker.emailStatus.temporarilyFailed' },
    };

    getBadgeDisplay(applicantIndividualMessage: ApplicantIndividualMessage): BadgeDisplay | undefined {
        return this.statusBadges[applicantIndividualMessage.status];
    }
}
